import { atom } from "recoil";

export const roomGameTypeAtom = atom<string>({
  key: "roomGameTypeAtom",
  default: "",
});
